import styled from 'styled-components';
import React from 'react';
import icon_20_80 from 'Images/icons/opticalDistribution/20_80.svg';
import icon_50_50 from 'Images/icons/opticalDistribution/50_50.svg';
import icon_80_20 from 'Images/icons/opticalDistribution/80_20.svg';
import accent from 'Images/icons/opticalDistribution/accent.svg';
import assymetric from 'Images/icons/opticalDistribution/assymetric.svg';
import direct from 'Images/icons/opticalDistribution/direct.svg';
import flood from 'Images/icons/opticalDistribution/flood.svg';
import graphical from 'Images/icons/opticalDistribution/graphical.svg';
import grazing from 'Images/icons/opticalDistribution/grazing.svg';
import indirect from 'Images/icons/opticalDistribution/indirect.svg';
import omnidirectional from 'Images/icons/opticalDistribution/omnidirectional.svg';
import spot from 'Images/icons/opticalDistribution/spot.svg';
import streetOptics from 'Images/icons/opticalDistribution/streetOptics.svg';
import upAndDown from 'Images/icons/opticalDistribution/upAndDown.svg';

import VeryWideFlood from 'Images/icons/opticalDistribution/VeryWideFlood.svg';
import WallWash from 'Images/icons/opticalDistribution/WallWash.svg';
import WideFlood from 'Images/icons/opticalDistribution/WideFlood.svg';
import Super from 'Images/icons/opticalDistribution/Super.svg';
import Gobo from 'Images/icons/opticalDistribution/Gobo.svg';
import Elliptica from 'Images/icons/opticalDistribution/Elliptica.svg';

import noCombination from 'Images/icons/no_combination.svg';

const OpticalDistributionImageContainer = styled.div`
  background-image: url(${props => props.src});
  box-sizing: inherit;
`;
const icons = {
  '112': direct,
  '113': icon_80_20,
  '114': icon_50_50,
  '115': icon_20_80,
  '116': indirect,
  '117': omnidirectional,
  '118': grazing,
  '119': accent,
  '120': upAndDown,
  '121': graphical,
  '122': spot,
  '123': flood,
  '124': assymetric,
  '125': streetOptics,
  '364': VeryWideFlood,
  '363': WideFlood,
  '365': WallWash,
  '362': Super,
  '366': Elliptica,
  '367': Gobo,
  noCombination: noCombination,
};
const OpticalDistribution = ({ icon }) =>
  icons[icon] ? (
    <OpticalDistributionImageContainer src={icons[icon]} />
  ) : (
    <OpticalDistributionImageContainer src={icons.noCombination} alt="" />
  );

export default OpticalDistribution;
